import { ValidationErrors } from '@angular/forms';

export class FieldValidatorTracker {
  constructor(
    public formControlId: string,
    public formControlName: string,
    public errorType: string,
    public failedValidationError: string
  ) {}

  navigateToFailedField() {
    var field = null;
    if (this.formControlId) {
      field = document.getElementById(this.formControlId);
    } else if (this.formControlName) {
      field = document.querySelector(`[formControlName='${this.formControlName}']`);
    }

    if (field) {
      field.scrollIntoView({ block: 'center', behavior: 'smooth' });
    } else {
      console.error(`could not find element for ${JSON.stringify(this)}`);
    }
  }
}

const enterPhone = 'You must enter a valid phone number.';
const customValidationRules: {
  name: string;
  errorType: string;
  message: string;
}[] = [
  {
    name: 'email',
    errorType: 'email',
    message: 'Email is in wrong format'
  },
  {
    name: 'races',
    errorType: 'notEmpty',
    message:
      'Race/Ethnicity is a required field. Please select "Prefer not to answer" if you do not want to answer.'
  },
  {
    name: 'gender',
    errorType: 'notEmpty',
    message:
      'Gender is a required field. Please select "Prefer not to answer" if you do not want to answer.'
  },
  {
    name: 'linkedInProfile',
    errorType: 'urlPattern',
    message:
      'LinkedIn Profile must be a valid Url. Please make sure to include https:// at the beginning.'
  },
  {
    name: 'phoneNumberRaw', //a partially missing phone like '(513) 4' will trigger this
    errorType: 'required',
    message: enterPhone
  },
  {
    name: 'phoneNumberRaw', //similar to required, extra digits will trigger this '(513) 555-55552'
    errorType: 'validatePhoneNumber',
    message: enterPhone
  },
  {
    name: 'phoneNumber', //validation doesn't kick in on short phone numbers, so min is set to 5 characters. '+877'
    errorType: 'minlength',
    message: enterPhone
  },
  {
    name: 'prefix',
    errorType: 'maxlength',
    message: 'Prefix is limited to 15 characters.'
  },
  {
    name: 'suffix', //validation doesn't kick in on short phone numbers, so min is set to 5 characters. '+877'
    errorType: 'maxlength',
    message: 'Suffix is limited to 15 characters.'
  }
];

export const getFailedValidationMessage = (fieldName: string, validationType: string): string => {
  const matchingRule = customValidationRules.find(
    (validationRule) =>
      validationRule.name === fieldName && validationRule.errorType === validationType
  );
  if (matchingRule) return matchingRule.message;
  return '';
};

export const getAllControlErrors = (
  fieldId: string,
  fieldName: string,
  control: { errors: ValidationErrors }
): FieldValidatorTracker[] => {
  if (!control?.errors) {
    return [];
  }
  const controlErrors = control?.errors;
  const failedValidations: FieldValidatorTracker[] = [];
  Object.keys(controlErrors).forEach((keyError) => {
    var validationMessage = getFailedValidationMessage(fieldName, keyError);
    if (validationMessage === '') {
      validationMessage =
        typeof controlErrors[keyError] === 'string' ? controlErrors[keyError] : '';
    }

    if (validationMessage !== '') {
      failedValidations.push(
        new FieldValidatorTracker(fieldId, fieldName, keyError, validationMessage)
      );
    }
  });

  return failedValidations;
};
